module.exports = __webpack_public_path__ + "static/img/LRbg.28df679b.jpg";